export interface RuntimeConfig {
  API_BASE_URL: string;
  SUPABASE_URL: string;
  SUPABASE_ANON_KEY: string;
}

declare global {
  interface Window {
    __APP_CONFIG__?: Partial<RuntimeConfig>;
  }
}

const runtime = window.__APP_CONFIG__ ?? {};

export const config: RuntimeConfig = {
  API_BASE_URL: runtime.API_BASE_URL || import.meta.env.VITE_API_BASE_URL || '/api',
  SUPABASE_URL: runtime.SUPABASE_URL || import.meta.env.VITE_SUPABASE_URL || '',
  SUPABASE_ANON_KEY: runtime.SUPABASE_ANON_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY || '',
};
